jQuery( function($) {
  window.archive = {}

  window.archive.morePosts = function(e) {
    let $this = $(this)

    e.preventDefault()

    $this
      .addClass('loading')
      .attr( 'disabled', 'disabled' )

    $.get( $this.data('href'), function( data, status ) {
      let content = $( $.parseHTML( data ) ).find('.groups').html()
      let carouselContent = $( $.parseHTML( data ) ).find('#preview-carousel').html()

      $this
        .removeClass('loading')
        .removeAttr('disabled')

      $this.replaceWith( content )

      $('#preview-carousel').slick( 'slickAdd', carouselContent )

      window.archive.observer()
    })
  }

  window.archive.observerCallback = function(entries, observer) {
    entries.forEach( entry => {
      if( entry.isIntersecting ) {
        let $group = $(entry.target)
        let $canonical = $('[rel=canonical]')

        history.pushState({ state: $group.data('paged') }, '', $group.data('url') )
        $canonical.attr( 'href', $group.data('canonical') )
      }
    })
  }

  window.archive.observer = function() {
    if ('IntersectionObserver' in window) {
      let groups = document.querySelectorAll('.group')
      let object = new IntersectionObserver(
        window.archive.observerCallback
      )
      for( group of groups ) {
        if( ! group.classList.contains('observed') ) {
          object.observe( group )
          group.classList.add('observed')
        }
      }
    }
  }

  window.archive.eventListeners = function() {
    $('.groups').on( 'click', '.load-more', window.archive.morePosts )
  }

  window.archive.observer()
  window.archive.eventListeners()
})



// WEBPACK FOOTER //
// ./src/js/archive.js